import ProCTALink from './ProCTALink';

export default ProCTALink;
